// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__TvvJ1","preview":"style_preview__9pcEH"};